import { render, staticRenderFns } from "./auditRecordList.vue?vue&type=template&id=3acb1d68"
import script from "./auditRecordList.vue?vue&type=script&lang=js"
export * from "./auditRecordList.vue?vue&type=script&lang=js"
import style0 from "./auditRecordList.vue?vue&type=style&index=0&id=3acb1d68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports